import momentLocale from 'moment/min/moment-with-locales'
import 'moment-timezone'
import moment from 'moment'

export const date = (x, langCode) => {
  (langCode === 'GB') ? momentLocale.locale('en') : (langCode === 'NO') ? momentLocale.locale('nb') : momentLocale.locale(langCode)
  x = (typeof x === 'object') ? x._d : x
  if (langCode === 'GB') {
    return momentLocale(x).format('DD MMM YYYY')
  } else if (langCode === 'JA') {
    return momentLocale(x).format('YYYY-MM-DD')
  } else {
    return momentLocale(x).format('L')
  }
}
export const dateTime = (x) =>
  moment(x).format('MMM-DD-YYYY HH:mm:ss A')

export const UKTime = (x) => {
  let time
  if (x) {
    time = moment(x).tz('Europe/London')
  } else {
    time = moment().tz('Europe/London')
  }
  return time
}



// WEBPACK FOOTER //
// ./src/format.js